import React from "react";
import PropTypes from "prop-types";
import { getMessage } from "../data/locales";
import { PDF_ZOOM_MAX, PDF_ZOOM_MIN } from "../pdf/getPdfFitWidthScale";

/**
 * @param {{
 *   zoom: number,
 *   isFullscreen: boolean,
 *   actionsEnabled: boolean,
 *   canDownload: boolean,
 *   onZoomOut: () => void,
 *   onZoomIn: () => void,
 *   onToggleFullscreen: () => void,
 *   newTabHref: string,
 *   onDownload: () => void,
 * }} props
 */
function CoursePdfViewerToolbar({
  zoom,
  isFullscreen,
  actionsEnabled,
  canDownload,
  onZoomOut,
  onZoomIn,
  onToggleFullscreen,
  newTabHref,
  onDownload,
}) {
  const zoomPercent = Math.round(zoom * 100);

  return (
    <div
      className="course-material-pdf-toolbar"
      role="toolbar"
      aria-label={getMessage("campus.pdfToolbarLabel")}
    >
      <div className="course-material-pdf-zoom">
        <button
          type="button"
          className="course-material-pdf-toolbar-btn"
          onClick={onZoomOut}
          disabled={zoom <= PDF_ZOOM_MIN}
          aria-label={getMessage("campus.pdfZoomOut")}
        >
          −
        </button>
        <span className="course-material-pdf-zoom-value" aria-live="polite">
          {getMessage("campus.pdfZoomLabel", { percent: zoomPercent })}
        </span>
        <button
          type="button"
          className="course-material-pdf-toolbar-btn"
          onClick={onZoomIn}
          disabled={zoom >= PDF_ZOOM_MAX}
          aria-label={getMessage("campus.pdfZoomIn")}
        >
          +
        </button>
      </div>
      <button
        type="button"
        className="course-material-pdf-toolbar-btn"
        onClick={onToggleFullscreen}
        aria-pressed={isFullscreen}
      >
        {isFullscreen
          ? getMessage("campus.pdfExitFullscreen")
          : getMessage("campus.pdfFullscreen")}
      </button>
      {canDownload && newTabHref ? (
        <a
          className="course-material-pdf-toolbar-btn course-material-pdf-toolbar-link"
          href={newTabHref}
          target="_blank"
          rel="noopener noreferrer"
        >
          {getMessage("campus.pdfOpenInNewTab")}
        </a>
      ) : canDownload ? (
        <button
          type="button"
          className="course-material-pdf-toolbar-btn"
          disabled
        >
          {getMessage("campus.pdfOpenInNewTab")}
        </button>
      ) : null}
      {canDownload ? (
        <button
          type="button"
          className="course-material-pdf-toolbar-btn"
          onClick={onDownload}
          disabled={!actionsEnabled}
        >
          {getMessage("campus.pdfDownload")}
        </button>
      ) : null}
    </div>
  );
}

CoursePdfViewerToolbar.propTypes = {
  zoom: PropTypes.number.isRequired,
  isFullscreen: PropTypes.bool.isRequired,
  actionsEnabled: PropTypes.bool.isRequired,
  canDownload: PropTypes.bool.isRequired,
  onZoomOut: PropTypes.func.isRequired,
  onZoomIn: PropTypes.func.isRequired,
  onToggleFullscreen: PropTypes.func.isRequired,
  newTabHref: PropTypes.string.isRequired,
  onDownload: PropTypes.func.isRequired,
};

export default CoursePdfViewerToolbar;
